import { Component, Injector, Input, ViewChild } from '@angular/core';

import { AmorphicService } from '../../../../services/amorphic/amorphic.service';
import { BaseFormComponent } from '../base-form.component';
import { BasicTextInputComponent } from '../basic-text-input/basic-text-input.component';

@Component({
  moduleId: module.id,
  selector: 'basic-text',
  templateUrl: './basic-text.component.html',
})
export class BasicTextComponent extends BaseFormComponent {
  @ViewChild('textInputComponent') textInputComponent: BasicTextInputComponent;
  inputText: string;
  levelClass: string;
  @Input() disableConditionally: boolean = false;
  @Input() propertyName: string;

  constructor(protected injector: Injector, private amorphicService: AmorphicService) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.levelClass = this.getLevelClass();
  }

  resetValue() {
    this.inputText = '';
    this.textInputComponent.resetValue();
  }

  updateFromModel() {}
}
